import Snap from 'snapsvg';

class Beziercurve {
  constructor(startPt, controlPt1, controlPt2, endPt) {
    this.startPt = startPt;
    this.controlPt1 = controlPt1;
    this.controlPt2 = controlPt2;
    this.endPt = endPt;
    this.length = this.getLength();
  }

  // Bezier curves methods

  getXY(percent) {
    const CubicN = (pct, a, b, c, d) => {
      const t2 = pct * pct;
      const t3 = t2 * pct;
      return a + (-a * 3 + pct * (3 * a - a * pct)) * pct
        + (3 * b + pct * (-6 * b + b * 3 * pct)) * pct
        + (c * 3 - c * 3 * pct) * t2
        + d * t3;
    };
    const x = CubicN(percent, this.startPt.x, this.controlPt1.x, this.controlPt2.x, this.endPt.x);
    const y = CubicN(percent, this.startPt.y, this.controlPt1.y, this.controlPt2.y, this.endPt.y);
    return ({ x: Math.floor(x), y: Math.floor(y) });
  }

  getLength() {
    const foo = [];
    let length = 0;
    for (let i = 0; i <= 30; i += 1) {
      foo[i] = this.getXY(i / 30);
    }
    for (let i = 1; i <= 30; i += 1) {
      const a = foo[i - 1].x - foo[i].x;
      const b = foo[i - 1].y - foo[i].y;
      length += Math.sqrt(a * a + b * b);
    }
    return length;
  }
}

class BoardPassGenerator {
  constructor(coordinates, stepNum, dom) {
    this.numberSteps = stepNum - 1;
    this.coordinates = coordinates;
    this.snap = Snap(dom);
    this.sellingCount = 0;
    this.bezierCurves = [];
    this.pathSections = [0];
    this.totalLength = 0;
  }

  // initialize the board
  init(cb) {
    // we create instances of : Beziercurve
    this.coordinates.forEach((coordinate, i) => {
      this.bezierCurves[i] = new Beziercurve(
        coordinate[0],
        coordinate[1],
        coordinate[2],
        coordinate[3],
      );
    });
    // generate an array indexing all the sections lengths :
    for (let i = 0; i < this.bezierCurves.length; i += 1) {
      this.pathSections.push(this.bezierCurves[i].length + this.pathSections[i]);
    }
    // then we calculate the total length of the curve
    this.totalLength = this.pathSections[this.pathSections.length - 1];
    // reset
    this.sellingCount = 0;
    this.drawSteps(this.numberSteps, cb);
    if (cb && typeof cb === 'function') cb();
  }

  drawSteps(j) {
    for (let i = 0; i <= j; i += 1) {
      let xy = {};
      let section = [];
      let sectionPercent = 0;
      const distanceFromStart = i / j * this.totalLength;
      const { pathSections } = this;
      // find which section 'distanceFromStart' belongs to
      section = pathSections.filter(value => value <= distanceFromStart).length - 1;
      // make sure we don't go beyond the array for the last step!
      section = Math.min(section, pathSections.length - 2);
      sectionPercent = (section > 0) ? ((distanceFromStart - pathSections[section])
        / (pathSections[section + 1] - pathSections[section]))
        : (distanceFromStart / pathSections[section + 1]);
      xy = this.bezierCurves[section].getXY(sectionPercent);
      this.drawStep(xy, i);
    }
  }

  drawStep(point) {
    // we get the kind of the step (regular, mystery, star, checkpoint)
    // then we draw the step at the computed position
    const icon = this.snap.use('position');
    this.snap.g(icon).attr({
      class: 'position',
      transform: `translate(${point.x}, ${point.y})`,
    });
  }
}

export const generateCurve = (coordinates, stepNum, dom) => {
  const boardPassGenerator = new BoardPassGenerator(coordinates, stepNum, dom);
  boardPassGenerator.init();
};
